import { render, staticRenderFns } from "./eventtokenredemption.vue?vue&type=template&id=f0ee54b4&"
import script from "./eventtokenredemption.vue?vue&type=script&lang=js&"
export * from "./eventtokenredemption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports